module.exports = __webpack_public_path__ + "static/img/img9.34f1cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/product/images/img9.png
// module id = J4jv
// module chunks = 1